export const SET_AUTH = (state, auth) => {
  state.auth = auth;
};

export const SET_LEADS = (state, leads) => {
  state.leads = leads;
};
export const TOTAL_LEADS = (state, total) => {
  state.totalLeads = total;
};
export const SINGLE_LEAD = (state, lead) => {
  state.lead = lead;
};

export const SET_GROUPS = (state, groups) => {
  state.groups = groups;
};
export const SET_TEAMS = (state, teams) => {
  state.teams = teams;
};
export const SET_UNREADNOTIFICATION = (state, unreadnotifications) => {
  state.unreadnotifications = unreadnotifications;
};
